import React, { useState } from 'react';
import { auth } from '../firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import './Auth.css';

function Auth({ onClose, onLogin }) {
    const [isLogin, setIsLogin] = useState(true);
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            if (isLogin) {
                // LOGIN
                const userCredential = await signInWithEmailAndPassword(
                    auth, 
                    formData.email || formData.username, 
                    formData.password
                );
                
                const userData = {
                    uid: userCredential.user.uid,
                    email: userCredential.user.email,
                    username: userCredential.user.email.split('@')[0]
                };
                
                localStorage.setItem('currentUser', JSON.stringify(userData));
                onLogin(userData);
                onClose();
            } else {
                // REGISTER
                if (!formData.email || !formData.password) {
                    setError('Email and password are required');
                    setLoading(false);
                    return;
                }

                if (formData.password.length < 6) {
                    setError('Password must be at least 6 characters');
                    setLoading(false);
                    return;
                }

                const userCredential = await createUserWithEmailAndPassword(
                    auth,
                    formData.email,
                    formData.password
                );

                const userData = {
                    uid: userCredential.user.uid,
                    email: userCredential.user.email,
                    username: formData.username || userCredential.user.email.split('@')[0]
                };

                localStorage.setItem('currentUser', JSON.stringify(userData));
                onLogin(userData);
                onClose();
            }
        } catch (err) {
            console.error('Auth error:', err);
            
            // Mensajes de error en español
            if (err.code === 'auth/email-already-in-use') {
                setError('This email is already registered');
            } else if (err.code === 'auth/invalid-email') {
                setError('Invalid email address');
            } else if (err.code === 'auth/user-not-found') {
                setError('User not found');
            } else if (err.code === 'auth/wrong-password') {
                setError('Incorrect password');
            } else if (err.code === 'auth/invalid-credential') {
                setError('Invalid credentials');
            } else {
                setError(err.message || 'An error occurred');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    return (
        <div className="auth-overlay" onClick={onClose}>
            <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
                <button className="auth-close" onClick={onClose}>✕</button>
                
                <div className="auth-header">
                    <h2>{isLogin ? 'Welcome Back' : 'Create Account'}</h2>
                    <p>{isLogin ? 'Sign in to access your charts' : 'Join to save your work in the cloud'}</p>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    {!isLogin && (
                        <div className="form-group">
                            <input
                                type="text"
                                name="username"
                                placeholder="Username (optional)"
                                value={formData.username}
                                onChange={handleChange}
                                autoComplete="username"
                                disabled={loading}
                            />
                        </div>
                    )}

                    <div className="form-group">
                        <input
                            type="email"
                            name={isLogin ? 'username' : 'email'}
                            placeholder="Email"
                            value={isLogin ? formData.username : formData.email}
                            onChange={handleChange}
                            autoComplete="email"
                            disabled={loading}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={formData.password}
                            onChange={handleChange}
                            autoComplete={isLogin ? 'current-password' : 'new-password'}
                            disabled={loading}
                            required
                        />
                    </div>

                    {error && <div className="auth-error">{error}</div>}

                    <button 
                        type="submit" 
                        className="auth-submit"
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : (isLogin ? 'Sign In' : 'Create Account')}
                    </button>
                </form>

                <div className="auth-switch">
                    <p>
                        {isLogin ? "Don't have an account? " : "Already have an account? "}
                        <button 
                            onClick={() => {
                                setIsLogin(!isLogin);
                                setError('');
                                setFormData({ username: '', email: '', password: '' });
                            }}
                            disabled={loading}
                        >
                            {isLogin ? 'Sign Up' : 'Sign In'}
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Auth;
